// Copyright 2021 [LIPM]
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// http://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
//    limitations under the License.
<template>
  <div>
    <header>
      <slot name="header"></slot>
    </header>
    <form>
      <label>
        {{ label }}
        <text-reader :label="buttonLabel" @load="readText"></text-reader>
      </label>
    </form>
  </div>
</template>

<script>
import TextReader from './TextReader.vue'

export default {
  components: {
    TextReader
  },
  props: {
    label: { type: String, default: '' },
    buttonLabel: { type: String, default: 'Read file' }
  },
  methods: {
    readText (event) {
      this.$emit('load', event)
    }
  }
}
</script>

<style></style>
